export default {
  gmv: 'GMV',
  paidGmv: 'Paid GMV',
  grossRevenue: 'Gross Revenue',
  orders: 'Orders',
  paidOrders: 'Paid Orders',
  visitors: 'Visitors',
  buyers: 'Buyers',
  buyers2: 'Buyers',
  paidBuyers: 'Paid Buyers',
  cvr: 'CVR',
  paidCVR: 'Paid CVR',
  byDay: 'By Day',
  byWeek: 'By Week',
  byMonth: 'By Month',
  days: 'Days',
  weeks: 'Weeks',
  months: 'Months',
  yesterday: 'Yesterday',
  thisWeekMonYesterday: 'This week(Mon-Yesterday)',
  lastWeekMonSun: 'Last week(Mon-Sun)',
  last7days: 'Last 7 days',
  last14days: 'Last 14 days',
  storeReport: 'Store Report',
  productReport: 'Product Report',
  region: 'Country Site',
  skuId: 'Sku ID',
  search: 'Search',
  export: 'Export',
  comparisonPeriod: 'Comparison Period',
  statisticsPeriod: 'Statistics Period',
  pageViews: 'Page Views',
  paidQty: 'Paid Qty',
  ordersQty: 'Order Qty',
  productInfo: 'Product Information',
  operation: 'Operation',
  details: 'Details',
  timeSeries: 'Time series',
  dateTable: 'Data table',
  exportData: 'Export Data',
  selectDate: 'Select date',
  storePerformance: 'Store Performance',
  preferredSeller: 'Preferred Store',
  preferred: 'Preferred',
  excellent: 'Excellent',
  good: 'Good',
  goodToImprove: 'Good to improve',
  bad: 'Bad',
  metricsDidNotMeetTarget: ' metrics did not meet target. Please check the metric details below to improve your store performance',
  performBetterToFulfill: 'Perform better to fulfill',
  moreCriteriaToJoin: ' more criteria to join Preferred Store and gain privileges.',
  salesPerformance: 'Sales Performance',
  fulfillmentPerformance: 'Fulfillment Performance',
  customerServicePerformance: 'Customer Service Performance',
  metricFailed: ' metric(s) failed',
  viewDetails: 'View Details',
  view: 'View',
  metricsDetails: 'Metrics Details',
  metrics: 'Metrics',
  myStore: 'My Store',
  target: 'Target',
  status: 'Status',
  action: 'Action',
  uniqueVisitors: 'Unique Visitors',
  ordersNum: 'Orders',
  sequentialOrderGrowthRate: 'Sequential Order Growth Rate',
  meet: 'Meet',
  fail: 'Fail',
  meetFulfillment: 'Meet',
  failFulfillment: 'Fail',
  howToImprove: 'How to improve',
  preFulfillmentCancelRate: 'Pre-fulfillment Cancel Rate',
  lateDispatchingRate: 'Late Dispatching Rate',
  fastDispatchingRate: 'Fast Dispatching Rate',
  negativeRatingRate: 'Negative Rating Rate',
  sellerFaultAppealRate: 'Seller Fault Appeal Rate',
  chatEffectiveResponseRate: 'Chat Effective Response Rate',
  thePreferredSellerProgram: 'The "Preferred Store” program rewards high-performing stores. Stores in this program receive special privileges from the platform to boost their revenue.',
  congratulations: 'Congratulations!',
  yourStoreKeepGood: `Your store's outstanding performance has earned the "Preferred Store” privilege for this week. Keep up the good work!`,
  preferredSellerProgram: 'Preferred Store Program',
  criterias: 'Criterias',
  criteriasA: 'Criteria A',
  criteriasB: 'Criteria B',
  criteriasC: 'Criteria C',
  meetAllPerformanceTargets: 'Meet all performance targets',
  noLessThanExpanded: 'No less than',
  noLessThanExpanded2: 'days since your store was opened or expanded.',
  yourStorePoints: `Your store's cumulative penalty points is less than `,
  yourStorePoints2: `.`,
  gainFollowingPrivileges: `Gain the following privileges when all the above criterias are met`,
  knowMoreAboutPrivileges: 'Know more about privileges',
  privilegeA: 'Privilege A',
  privilegeB: 'Privilege B',
  privilegeC: 'Privilege C',
  displayThePreferredRate: 'Display the Preferred Store label for your products. This will increase the visitor-to-buyer conversion rate.',
  increaseSearchRanking: `Improve the ranking of your store's products in search results and category product listings.`,
  grantAdvertisingBill: `Grant a one-time sponsored ads bonus of `,
  grantAdvertisingBill2: ` shillings.You can use it to pay your advertising bill.`,
  close: 'Close',
  uniqueVisitorsTip: 'The number of unique users who visited the product details page in the last 4 weeks. Updated every Monday.',
  ordersTip: 'The number of orders paid by buyers in the last 4 weeks. Updated every Monday.',
  sequentialOrderGrowthRateTip: 'The growth rate of orders paid by buyers in the last 4 weeks compared to the previous 4 weeks. Updated every Monday.',
  preFulfillmentCancelRateTip: 'Calculate the proportion of non-FBK orders, paid by buyers in the last 2 to 5 weeks and not canceled by them, that were canceled due to seller-initiated cancellations, seller delays in shipping, or logistics non-pickup. Updated every Monday.',
  lateDispatchingRateTip: 'Calculate the proportion of non-FBK orders paid by buyers in the last 2 to 5 weeks and not canceled by them, where the packages were not delivered to platform drop-off station within the specified times (DS: 120 hours, GS: 168 hours). Updated every Monday.',
  fastDispatchingRateTip: 'Calculate the proportion of non-FBK orders paid by buyers in the last 2 to 5 weeks and not canceled by them, that were delivered to platform drop-off station within the specified timeframes (DS: 24 hours, GS: 72 hours). Updated every Monday.',
  negativeRatingRateTip: 'Calculate the proportion of 1/2-star ratings among all buyer order ratings excluding delivery service scores, over the past 8 weeks. Updated every Monday.',
  sellerFaultAppealRateTip: 'Calculate the proportion of after-sales cases confirmed by platform arbitration as seller-responsible out of the total confirmed after-sales cases in the last 8 weeks. Updated every Monday.',
  chatEffectiveResponseRateTip: 'Calculate the proportion of timely initial effective responses from sellers to buyer-initiated chats over the past 4 weeks, based on specified response timeframes determined by the time of chat initiation. Updated every Monday.',
  average: 'Average',
  lastXWeeks: 'Last {0} Weeks',
  lastXMonths: 'Last {0} Months',
  noData: 'No Data',
  ordersStore: 'Orders-store',
  ordersTarget: 'Orders-target',
  store: 'Store',
  setTarget: 'Target'
}
